<template>
  <div class="mb-4">
    <div
      class="bg-custom-light-green rounded-top d-lg-flex flex-row px-3 py-1 align-items-center bd-highlight"
    >
      <div class="d-flex flex-row w-80 bd-highlight">
        <div class="color-secondary-6 font-14 mr-1">
          Nombre de Custodio:
        </div>
        <div class="font-weight-bold font-16">
          {{ userName | empty }}
        </div>
      </div>
      <div>
        <custom-status-transaction
          :source="sourceDetails"
          :destination="destinationDetails"
        />
      </div>
    </div>

    <custom-callout
      has-toggle
      controlled
      class="border-radius-top-auto"
      :opened="item.isOpen"
      :border-color="item.statusColor"
      @click:open="onToggle()"
    >
      <div class="row m-0 d-flex align-items-center">
        <div class="col-md col-12 p-md-0">
          <div class="py-3">
            <custom-balloon
              dot
              class="mt-2"
              :background-color="item.statusColor"
              :text="item.statusName"
            />
          </div>
        </div>
        <div class="col-md-10 col-12 mb-3 mb-lg-0 pl-md-0">
          <div class="row font-weight-normal">
            <div class="col-md-3 col-12">
              <div class="color-secondary-6 font-14">
                Nombre de Material/Equipo:
              </div>
              <div class="color-black font-16">
                {{ item.equipmentName | empty }}
              </div>
            </div>
            <div class="col-md-2 col-12">
              <div class="color-secondary-6 font-14">
                Código:
              </div>
              <div class="color-black font-16">
                {{ item.itemCode | empty }}
              </div>
            </div>
            <div class="col-md col-12">
              <div class="color-secondary-6 font-14 ">
                Número de Solicitud:
              </div>
              <div class="color-black font-16">
                {{ item.requestCode | empty }}
              </div>
            </div>
            <div class="col-md col-12">
              <div class="color-secondary-6 font-14 ">
                Fecha de Solicitud:
              </div>
              <div class="color-black font-16">
                {{ item.requestDate | date }}
              </div>
            </div>
            <div class="col-md-2 col-12">
              <drop-down
                :items="actionItems"
                always-show-dropdown
                class="float-md-right mt-2 mt-md-1"
              />
            </div>
          </div>
        </div>
      </div>
      <template #edition>
        <div v-if="showInfoSection" class="p-4">
          <div class="px-3 rounded-top bg-white">
            <custom-tab
              content-class="mt-3"
              nav-class="nav-vue-underline mx-0 w-100"
              no-nav-style
              :default-active-tab="activeTab"
              @input="setCurrentTab"
            >
              <custom-tab-item title="Información Adicional">
                <additional-info :item="item" />
              </custom-tab-item>
              <custom-tab-item
                v-if="item.orderDetailId"
                title="Información de Solicitud"
              >
                <request-info :order="order" />
              </custom-tab-item>
              <custom-tab-item
                v-if="item.hasLog"
                title="Historial de Transferencia"
              >
                <history :data="history" @load="getHistory" />
              </custom-tab-item>
            </custom-tab>
          </div>
        </div>
        <div v-else-if="showAcceptance">
          <custom-action-form
            form-title="Razón de Aceptación"
            custom-icon="fa fa-check-circle text-orange"
            :form-info="item"
            :action="actions.ACCEPT"
            @close="close"
            @save="accept"
          />
        </div>
        <div v-else-if="showRejection">
          <custom-action-form
            form-title="Razón de Rechazo"
            custom-icon="fa fa-times-circle text-orange"
            :form-info="item"
            :action="actions.REJECT"
            @close="close"
            @save="reject"
          />
        </div>
        <div v-else-if="showSendToRoute">
          <send-to-route :item="item" @close="close" @save="sendToRoute" />
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import CustomBalloon from 'custom-balloon';
import { CustomTab, CustomTabItem } from 'custom-tabs';

import CustomStatusTransaction from '@/views/books/inventoryOrderBooks/components/CustomStatusTransaction.vue';

import CustomActionForm from './CustomActionForm.vue';
import SendToRoute from './SendToRoute.vue';
import AdditionalInfo from './AdditionalInfo.vue';
import RequestInfo from './RequestInfo.vue';
import History from './History.vue';
// import TransferInfo from "./TransferInfo.vue";

import transferService from '@/services/api/inventoryTransferMaterialsAndEquipments.api';
import orderService from '@/services/api/inventoryOrderMaterialsAndEquipments.api';

import TransferStatuses from '@/utils/constants/inventory/peiAtServiceTransferStatus';

const TABS = {
  ADDITIONAL_INFO: '0',
  REQUEST_INFO: 1,
  TRANSFER_HISTORY: 2,
};

const ACTIONS = {
  ACCEPT: 0,
  REJECT: 1,
  SEND_TO_ROUTE: 2,
  INFO: 3,
};

const HISTORY_SIZE = 2;

export default {
  name: 'TranferResultRow',
  mixins: [alertMixin],
  components: {
    CustomCallout,
    DropDown,
    CustomBalloon,
    CustomTab,
    CustomTabItem,
    CustomStatusTransaction,
    CustomActionForm,
    SendToRoute,
    AdditionalInfo,
    RequestInfo,
    History,
    // TransferInfo,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      order: null,
      currentAction: null,
      activeTab: TABS.ADDITIONAL_INFO,
      history: {
        page: 0,
        total: 0,
        size: HISTORY_SIZE,
        items: [],
      },
    };
  },
  computed: {
    actions() {
      return ACTIONS;
    },
    showAcceptance() {
      return this.currentAction == ACTIONS.ACCEPT;
    },
    showRejection() {
      return this.currentAction == ACTIONS.REJECT;
    },
    showSendToRoute() {
      return this.currentAction === ACTIONS.SEND_TO_ROUTE;
    },
    showInfoSection() {
      return this.currentAction === ACTIONS.INFO;
    },
    userName() {
      return this.item.user?.name ?? '';
    },
    sourceDetails() {
      return {
        title: this.item.caatFrom ?? 'Oficina Central',
        color: this.item.caatFromColor ?? '#D3D3D3',
        icon: 'custom-text-status fas fa-map-marker-alt mr-2',
      };
    },
    destinationDetails() {
      return {
        title: this.item.caatTo,
        color: this.item.caatToColor,
        icon: 'custom-text-status fas fa-map-marker-alt mr-2',
      };
    },
    actionItems() {
      return [
        {
          name: 'Enviar a Centro',
          icon: 'fas fa-arrow-circle-right text-success',
          visible: this.item.statusId == TransferStatuses.Approved,
          click: () => this.showForm(ACTIONS.SEND_TO_ROUTE),
        },
        {
          name: 'Aceptar',
          icon: 'fas fa-check-circle text-success',
          class: 'border-bottom',
          visible: this.isApproveRejectVisible,
          click: () => this.showForm(ACTIONS.ACCEPT),
        },
        {
          name: 'Rechazar',
          icon: 'fas fa-times-circle text-danger',
          visible: this.isApproveRejectVisible,
          click: () => this.showForm(ACTIONS.REJECT),
        },
        {
          name: 'Información Adicional',
          icon: 'fas fa-info-circle text-success',
          click: () => this.showInfoAtTab(TABS.ADDITIONAL_INFO),
        },
        {
          name: 'Información de Solicitud',
          icon: 'fas fa-info-circle text-success',
          visible: Boolean(this.item.orderDetailId),
          click: () => this.showInfoAtTab(TABS.REQUEST_INFO),
        },
        {
          name: 'Historial de Transferencia',
          icon: 'fas fa-history text-success',
          visible: this.item.hasLog,
          click: () => this.showInfoAtTab(TABS.TRANSFER_HISTORY),
        },
      ];
    },
    isApproveRejectVisible() {
      return (
        this.item.statusId == TransferStatuses.Submitted &&
        this.userHasPermissions(
          'academic.materialsandequipments.transfer.approve'
        )
      );
    },
  },
  methods: {
    async setCurrentTab(tab) {
      if (tab == TABS.REQUEST_INFO) await this.getOrder();
      else if (tab == TABS.TRANSFER_HISTORY) await this.getHistory();
      this.activeTab = tab;
    },
    async onToggle() {
      this.currentAction = ACTIONS.INFO;
      await this.setCurrentTab(TABS.ADDITIONAL_INFO);
      this.item.isOpen = !this.item.isOpen;
      const action = this.item.isOpen ? 'open' : 'close';
      this.$emit(action, this.item);
    },
    showForm(action) {
      this.currentAction = action;
      this.item.isOpen = true;
      this.$emit('open', this.item);
    },
    async showInfoAtTab(tab) {
      this.currentAction = ACTIONS.INFO;
      await this.setCurrentTab(tab);
      this.$emit('open', this.item);
    },
    close() {
      this.currentAction = null;
      this.onToggle();
    },
    refresh() {
      this.close();
      this.$emit('refresh');
    },
    async accept(payload) {
      await transferService.approve(this.item.id, payload);
      this.ShowToast(
        'Éxito',
        'La transferencia has sido aprobada exitosamente.',
        'success'
      );
      this.refresh();
    },
    async reject(payload) {
      await transferService.reject(this.item.id, payload);
      this.ShowToast(
        'Éxito',
        'La transferencia has sido rechazada exitosamente.',
        'success'
      );
      this.refresh();
    },
    async sendToRoute(payload) {
      await transferService.sendToRoute(this.item.id, payload);
      this.ShowToast(
        'Éxito',
        'La transferencia se ha enviado a ruta exitosamente.',
        'success'
      );
      this.refresh();
    },
    async getOrder() {
      if (this.order || !this.item.orderDetailId) return;
      const { data } = await orderService.trackRequestProgress(
        this.item.orderDetailId
      );
      this.order = data;
    },
    async getHistory(page = 1) {
      if (this.history.page === page) return;
      const { data } = await transferService.getHistory(this.item.id, {
        page,
        size: HISTORY_SIZE,
      });
      this.history.page = page;
      this.history.total = data.totalItemCount;
      this.history.items = [...this.history.items, ...data.data];
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .balloon-container.success {
  background-color: #a3e5b3;
}
::v-deep .balloon-container.warning {
  background-color: #f8b539;
}

::v-deep .nav-vue-underline li {
  flex: 1;
  text-align: center;
}

.border-radius-top-auto ::v-deep .border-radius--light {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.bg-custom-light-green {
  background-color: #d9e5dfba;
}
.bg-custom-light-tracked {
  background-color: #f7f7f7;
}
.custom-tab {
  --tab-active-color: #ff7058 !important;
}
</style>
